export const copyIconsHero = [
  {
    src: '/assets/images/icon/android-icon-3d.svg',
    width: 114,
    height: 109,
    className: ' icon-android right-2/12 bottom-2/12 ',
  },
  {
    src: '/assets/images/icon/bazel-icon-3d.svg',
    width: 98,
    height: 99,
    className: ' icon-bazel right-2/12 top-2/12 ',
  },
  {
    src: '/assets/images/icon/maven-icon-3d.svg',
    width: 136,
    height: 117,
    className: ' icon-maven left-2/12 bottom-2/12 -z-10',
  },
  {
    src: '/assets/images/icon/SBT-icon-3d.svg',
    width: 100,
    height: 99,
    className: ' icon-sbt md:bottom-2/12 -bottom-2 left-1/2 -translate-x-1/2 -z-10',
  },
  {
    src: '/assets/images/icon/GBT-icon-3d.svg',
    width: 135,
    height: 129,
    className: ' icon-gbt left-1/12 md:left-2/12 top-2/12 lg:left-2/12',
  },
];
